<template>
	<div class="sucess">
		<i class="fas fa-check-circle"></i>
		<span class="titulo"> {{ titulo }}</span>
		<div class="protocolo" v-if="protocolo">
			<span>Protocolo:</span>
			<div class="box-protocolo">
				<span class="num-protocolo">{{ protocolo }}</span>
			</div>
		</div>
		<hr>
		<span class="sub-titulo"> {{ subTitulo }} <span class="sub-titulo-negrito"> {{ subTituloNegrito }}</span></span>
	</div>
</template>

<script>
export default {
	name: 'Sucesso',
	props: ['titulo', 'protocolo', 'subTitulo', 'subTituloNegrito']
}
</script>

<style lang="scss" scoped>
	.sucess {
		background-color: #FEFEFE;
		display:flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		padding:50px 20px;
		border-radius:5px;
		position:fixed;
		width: 400px;
		height: 300px;
		left: 50%;
		top: 30%;
		margin-left: -250px;

		i {
			color:#01785A;
			font-size: 50px;
			margin-bottom: 18px;
		}

		.titulo {
			color:#052354;
			font-weight: 700;
			font-size: 18px;
			margin-bottom: 11px;
		}
		.protocolo {
			display:flex;
			flex-direction: column;
			align-items: center;
			color:#59708F;
			font-weight: 700;

			.box-protocolo {
				background-color: #59708F;
				padding:5px 20px;
				border-radius:20px;

				.num-protocolo {
					color:#fff;
					font-size: 14px;
				}
			}
		}

		hr {
			color:#00000012;
			width: 100%;
		}

		.sub-titulo {
			color:#8B94A7;
			align-content: center;
			color:#8B94A7;
			max-width: 250px;
			font-size: 16px;

			.sub-titulo-negrito {
				font-weight: 700;
			}
		}

		.nome {
			color:#EBECEF;
			border: 1px solid;
			border-radius: 5px;
			height: 40px;
			margin-bottom: 11px;

			input {
				background-color: #F8F9FB;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font: Condensed 16px Roboto;
			}
		}

		.descricao {
			color:#EBECEF;
			border: 1px solid;
			border-radius: 5px;
			height: 128px;
			margin-bottom: 16px;

			textarea {
				background-color: #F8F9FB;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font: Condensed 16px Roboto;
			}
		}
	}
</style>
